import React, { useEffect, useRef, useState } from "react";
import Chart from "chart.js";
import { REPORT_TYPES } from "../../../constants/app-constant";

const {
  JournalistNOARanking,
  JournalistNOATrend,
  SOV_NOA_TREND,
  JournalistTonalityNOARanking,
  PublicationNOATrend,
  SOVTonality,
  SOVRanking,
  TonalityNAORanking,
  PublicationNOARanking,
  CityWiseNOARanking,
  SOVPublication,
  PLATFORM_RANK,
  PLATFORM_TONALITY,
  PLATFORM_TREND,
} = REPORT_TYPES;
export const BarChartVertical = function ({
  graphApiResponse,
  chartTitle,
  yAxisMin,
  beginAtZero,
  onEntityClick,
  entityList,
  reportType,
  dataByReportType,
  editionList,
  isEmbededWidget,
}) {
  const chartContainer = useRef(null);
  const [chartInstance, setChartInstance] = useState(null);
  const [barChartData, setBarChartData] = useState({});
  const [showLegends, setShowLegends] = useState(true);
  useEffect(() => {
    setBarChartData(graphApiResponse);
    if (
      graphApiResponse &&
      graphApiResponse.datasets &&
      graphApiResponse.datasets.length <= 1
    ) {
      setShowLegends(false);
    }
  }, [graphApiResponse]);

  useEffect(() => {
    redrawChart();
  }, [barChartData, showLegends]);

  const redrawChart = () => {
    try {
      if (
        !barChartData ||
        !chartContainer ||
        !chartContainer.current ||
        !Object.keys(barChartData).length
      ) {
        return;
      }
      if (chartInstance) {
        chartInstance.data = barChartData;
        chartInstance.update();
        return;
      }
      const ctx = chartContainer.current.getContext("2d");
      const chart = new Chart(ctx, {
        type: "bar",
        data: barChartData, // setChartData will go away after actual data
        options: {
          plugins: {
            labels: false,
          },
          events: ["click", "mousemove"],
          elements: {
            rectangle: {
              borderWidth: 2,
            },
          },
          responsive: true,
          title: {
            display: !!chartTitle,
            text: chartTitle,
            margin: 10,
          },
          scales: {
            yAxes: [
              {
                display: true,
                ticks: (() => {
                  const ticks = {};
                  if (typeof yAxisMin !== undefined && yAxisMin !== "") {
                    ticks.suggestedMin = yAxisMin;
                  }
                  if (typeof beginAtZero !== undefined) {
                    ticks.beginAtZero = beginAtZero;
                  }
                  ticks.userCallback = function (label) {
                    if (Math.floor(label) === label) {
                      return label;
                    }
                  };
                  return ticks;
                })(),
              },
            ],
          },
          legend: {
            display: showLegends,
            labels: {
              boxWidth: 12,
            },
            maxHeight: 65,
          },
          exporting: {
            chartOptions: {
              legend: {
                enabled: true,
                verticalAlign: "bottom",
                maxHeight: 500,
                margin: 25,
              },
            },
          },
        },
      });
      setChartInstance(chart);
    } catch (e) {}
  };

  const handleBarClick = (e, { label, legend }) => {
    try {
      let routeParams = {
        entityId: null,
        vertical: null,
        date: null,
      };
      let clickedEntity = label;
      if (
        reportType === SOV_NOA_TREND ||
        reportType === JournalistNOARanking ||
        reportType === JournalistNOATrend ||
        reportType === PublicationNOARanking ||
        reportType === PublicationNOATrend ||
        reportType === PLATFORM_RANK ||
        reportType === PLATFORM_TREND
      ) {
        clickedEntity = legend;
      }
      if (
        reportType === SOV_NOA_TREND ||
        reportType === JournalistNOATrend ||
        reportType === PublicationNOATrend ||
        reportType === PLATFORM_TREND
      ) {
        routeParams.date = label;
      }
      if (reportType === JournalistNOARanking) {
        routeParams.sourceName = label;
      }
      if (reportType === PublicationNOARanking) {
        const clickedPublication = dataByReportType.filter(
          (elm) => elm.publication_name == label
        )[0];
        routeParams.publication = clickedPublication;
      }
      if (reportType == REPORT_TYPES.SOV) {
        routeParams.date = label;
      }
      if (reportType === CityWiseNOARanking) {
        const clickedEdition = editionList.filter(
          (elm) => elm.edition_name == legend
        )[0];
        routeParams.edition = clickedEdition;
      }
      if (
        reportType === JournalistTonalityNOARanking ||
        reportType === TonalityNAORanking ||
        reportType === PLATFORM_TONALITY
      ) {
        const tone = legend;
        routeParams.tonality = tone;
      }
      if (reportType == PLATFORM_RANK) {
        routeParams.channel_type = label;
      }

      let entity =
        entityList &&
        entityList.filter(
          (elm) =>
            clickedEntity == elm.entity_display_name?.trim() ||
            clickedEntity == elm.name || label == elm.entity_name?.trim()
        )[0];
      routeParams.entityId = entity && entity.id.toString();
      onEntityClick(e, routeParams);
    } catch (e) {
      onEntityClick(e, {});
    }
  };

  return (
    <div className={isEmbededWidget ? "biggerWidget" : ""}>
      <canvas
        ref={chartContainer}
        onClick={(e) => {
          let activePoint = chartInstance.getElementAtEvent(e)[0];
          if (activePoint) {
            const clickedEntity =
              graphApiResponse.labels[activePoint["_index"]];
            const legend =
              activePoint._chart.legend.legendItems[activePoint._datasetIndex]
                .text;
            handleBarClick(e, { legend, label: clickedEntity });
          }
        }}
      ></canvas>
    </div>
  );
};
